<div class="modal-header">
  <div class="d-flex align-items-center gap-3 flex-1">
    <h6 class="modal-title"><i class="far fa-user"></i> <ng-container i18n>User Detail</ng-container></h6>
    <div class="flex-fill"></div>
  </div>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="user-contact-banner p-3 d-flex align-items-center gap-3">
  <div style="height: 80px; margin: -1rem 0; bottom: -0.5rem" class="position-relative">
    <ng-container *ngIf="user?.attributes?.gender as gender; else avatar">
      <img *ngIf="gender === 'male'" src="/assets/images/man.png" alt="" class="h-100" />
      <img *ngIf="gender === 'female'" src="/assets/images/woman.png" alt="" class="h-100" />
    </ng-container>
    <ng-template #avatar>
      <app-avatar [text]="user.name" [size]="76" [border]="2" borderColor="white"></app-avatar>
    </ng-template>
  </div>
  <div class="flex-fill">
    <h5>
      {{ user.name }}
      <small class="text-muted text-sm"
        >(<ng-container i18n>User ID</ng-container>: {{ user.id }}) <app-copy-icon [content]="user.id"></app-copy-icon
      ></small>
    </h5>
    <div class="text-sm d-flex align-items-center gap-3">
      <div class="d-flex align-items-center gap-2" i18n-matTooltip matTooltip="Phone">
        <i class="cs-icon cs-icon-phone text-primary"></i>
        <ng-template [ngTemplateOutlet]="field" [ngTemplateOutletContext]="{ text: user.phoneView }"></ng-template>
        <app-copy-icon [content]="user.phone" *ngIf="user.phone"></app-copy-icon>
      </div>
      <div class="d-flex align-items-center gap-2" i18n-matTooltip matTooltip="Email">
        <i class="cs-icon cs-icon-envelope text-danger"></i>
        {{ user.primaryEmail }}
        <app-copy-icon [content]="user.primaryEmail" *ngIf="user.primaryEmail"></app-copy-icon>
      </div>
      <div
        class="d-flex align-items-center gap-2 text-capitalize"
        i18n-matTooltip
        matTooltip="Gender"
        *ngIf="user?.attributes?.gender as gender"
      >
        <i
          class="cs-icon"
          [ngClass]="{ 'cs-icon-male text-info': gender === 'male', 'cs-icon-female text-indigo': gender === 'female' }"
        ></i>
        {{ gender }}
      </div>
    </div>
  </div>
  <button class="btn btn-light btn-circle" (click)="onEdit()" matTooltip="Edit user details">
    <i class="cs-icon cs-icon-pencil"></i>
  </button>
</div>
<div class="modal-body p-0 bg-none">
  <div class="d-flex flex-column p-3 gap-3 container-box">
    <div class="d-flex gap-2">
      <i class="cs-icon cs-icon-gps2 mt-1 text-info"></i>
      <div>
        <div class="text-semi-bold" i18n>Address</div>
        <div>
          <ng-template
            [ngTemplateOutlet]="field"
            [ngTemplateOutletContext]="{ text: (user.address | address : false) }"
          ></ng-template>
        </div>
      </div>
    </div>
    <div class="d-flex gap-4">
      <div class="d-flex gap-2">
        <i class="cs-icon cs-icon-user-card mt-1 text-warning"></i>
        <div>
          <div class="text-semi-bold" i18n>User Role</div>
          <div>
            <ng-template [ngTemplateOutlet]="field" [ngTemplateOutletContext]="{ text: role }"></ng-template>
          </div>
        </div>
      </div>

      <div class="d-flex gap-2">
        <i class="cs-icon cs-icon-globe2 mt-1 text-indigo"></i>
        <div>
          <div class="text-semi-bold" i18n>Language</div>
          <div>
            <ng-template [ngTemplateOutlet]="field" [ngTemplateOutletContext]="{ text: language }"></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-box mt-3">
    <div class="d-flex align-items-center">
      <ul class="nav top-navbar pt-2" role="tablist">
        <li
          [class.active]="currentTab$.value === 'settings'"
          i18n-matTooltip
          matTooltip="Set the apps which user will be restricted from accessing"
        >
          <a (click)="currentTab$.next('settings')" i18n> User Settings </a>
        </li>
        <ng-container *ngIf="!isCurrentUser">
          <li
            [class.active]="currentTab$.value === 'rentals'"
            *ngIf="canRestrictRentals()"
            i18n-matTooltip
            matTooltip="Select the rentals which this user will be restricted from accessing."
            matTooltipPosition="above"
          >
            <a (click)="currentTab$.next('rentals')" i18n> Restricted Rentals </a>
          </li>
          <li
            [class.active]="currentTab$.value === 'ownerRentals'"
            *ngIf="isOwner(user)"
            i18n-matTooltip
            matTooltip="Select the rentals which will be visible for this owner."
            matTooltipPosition="above"
          >
            <a (click)="currentTab$.next('ownerRentals')" i18n> Owner Rentals </a>
          </li>
          <li [class.active]="currentTab$.value === 'attributes'">
            <a (click)="currentTab$.next('attributes')" i18n> Custom Attributes </a>
          </li>
        </ng-container>
      </ul>
      <div class="flex-fill"></div>
      <app-table-search
        (search)="rentalsSearchTerm = $event"
        class="mr-3"
        *ngIf="currentTab$.value === 'rentals' || currentTab$.value === 'ownerRentals'"
        style="min-width: 10rem"
      >
      </app-table-search>
    </div>
    <div [ngSwitch]="currentTab$.value">
      <ng-container *ngSwitchCase="'settings'">
        <ng-template [ngTemplateOutlet]="preferences"></ng-template>
      </ng-container>
      <div *ngSwitchCase="'rentals'" class="m-3">
        <app-restricted-rentals [user]="user" [searchTerm]="rentalsSearchTerm"></app-restricted-rentals>
      </div>
      <div *ngSwitchCase="'ownerRentals'" class="m-3">
        <app-owner-rentals [ownerId]="user.id" [searchTerm]="rentalsSearchTerm"></app-owner-rentals>
      </div>
      <div class="bg-white p-3 rounded-bottom" *ngSwitchCase="'attributes'">
        <app-entity-attributes
          #attrs
          entityType="user"
          [entityId]="user.id"
          [showActions]="true"
        ></app-entity-attributes>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    *ngIf="!isOwner(user)"
    (click)="onResetPassword()"
    i18n-matTooltip
    matTooltip="Send password reset email to this user."
    matTooltipPosition="below"
    type="button"
    class="btn btn-secondary-info"
  >
    <i class="fal fa-key"></i>
    <ng-container i18n>Reset Password</ng-container>
  </button>
  <div class="flex-fill"></div>

  <button
    *ngIf="!isCurrentUser"
    (click)="onDelete()"
    type="button"
    class="btn btn-secondary-danger"
    i18n-matTooltip
    matTooltip="Delete this user"
    matTooltipPosition="above"
  >
    <span class="cs-icon cs-icon-trash"></span>
    <ng-container i18n>Delete</ng-container>
  </button>
</div>

<ng-template #field let-text="text">
  <ng-container *ngIf="text">{{ text }}</ng-container>
  <span class="text-light text-xs" *ngIf="!text" i18n>Not Provided</span>
</ng-template>

<ng-template #preferences>
  <div class="p-4">
    <form [formGroup]="preferenceForm" *ngIf="!isCurrentUser">
      <div class="row gap-row-3">
        <div class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Disabled users cannot login to AdvanceCM or any of the AdvanceCM add-on applications."
            matTooltipPosition="above"
            formControlName="disabled"
          >
            Disable AdvanceCM Login
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableAutomata()" class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Enable this user to login to Automata."
            matTooltipPosition="above"
            formControlName="automata"
          >
            Enable Automata Login
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableSignature()" class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Enable this user to login to Signature."
            matTooltipPosition="above"
            formControlName="signature"
          >
            Enable Signature Login
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableOwnerCenter()" class="col-sm-4">
          <mat-checkbox
            i18n-matTooltip
            matTooltip="Enable this user to login to Owner Center."
            matTooltipPosition="above"
            formControlName="ownercenter"
          >
            <ng-container i18n *ngIf="!isOwner(user)">Enable Owner Center Login</ng-container>
            <ng-container i18n *ngIf="isOwner(user)">Enable Owner Portal Login</ng-container>
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableRategenie()" class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Enable this user to login to Rategenie."
            matTooltipPosition="above"
            formControlName="rategenie"
          >
            Enable Rategenie Login
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableWebready()" class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Enable this user to login to Webready."
            matTooltipPosition="above"
            formControlName="webready"
          >
            Enable Webready Login
          </mat-checkbox>
        </div>
        <div *ngIf="canEnableChecklist()" class="col-sm-4">
          <mat-checkbox
            i18n
            i18n-matTooltip
            matTooltip="Enable this user to login to Checklist."
            matTooltipPosition="above"
            formControlName="checklist"
          >
            Enable Checklist Login
          </mat-checkbox>
        </div>

        <div *ngIf="isOwner(user)" class="col-sm-4">
          <mat-checkbox
            [matTooltip]="
              !!preferenceForm.get('total').value
                ? 'Uncheck this field to hide booking charges from owner'
                : 'Check this field for showing booking charges to owner'
            "
            matTooltipPosition="above"
            formControlName="total"
            i18n
          >
            Show Charge Details
          </mat-checkbox>
        </div>
      </div>
      <app-staff-permissions [user]="user" *ngIf="isStaff(user)" class="my-4 d-block"></app-staff-permissions>
    </form>
    <form [formGroup]="preferenceForm" *ngIf="isCurrentUser" class="mb-3">
      <div class="row gap-row-3">
        <div class="col-sm-4">
          <mat-checkbox
            i18n
            formControlName="tooltip"
            matTooltip="Enable or Disable tooltips across the Application"
            i18n-matTooltip
          >
            Enable Application Tooltips
          </mat-checkbox>
        </div>
      </div>
    </form>

    <form [formGroup]="mfaForm" *ngIf="isCurrentAdmin || isCurrentUser">
      <hr *ngIf="!isCurrentUser" />
      <h6 i18n>Multi-Factor Authentication (MFA) Configuration</h6>

      <div class="alert alert-secondary-warning" *ngIf="isAccountMFAEnabled$ | async">
        <div class="alert-content" i18n>
          MFA is enforced at login for all users in this account. Your personal MFA setting cannot turn this off, but
          some actions, such as connecting payment gateways, still require it. You can choose your delivery method at
          any time.
        </div>
      </div>

      <ng-container *ngIf="!(isAccountMFAEnabled$ | async); else mfaEnforcedChip">
        <app-form-checkbox
          [checkedValue]="1"
          [uncheckedValue]="0"
          formControlName="status"
          class="mb-3 d-inline-block"
          [matTooltip]="mfaTooltip"
          i18n
          >Enable MFA</app-form-checkbox
        >
      </ng-container>
      <ng-template #mfaEnforcedChip>
        <span class="badge badge-secondary-success mb-3 d-inline-block">
          <i class="far fa-lock"></i> <ng-container i18n>MFA enforced account-wide</ng-container>
        </span>
      </ng-template>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2>
            <mat-select formControlName="delivery" i18n-placeholder placeholder="Delivery Method">
              <mat-option [value]="item.id" *ngFor="let item of mfaDeliveryMethodOptions">{{ item.label }}</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <button
            (click)="onResetTotp()"
            type="button"
            class="btn btn-secondary-danger align-input-row-end"
            matTooltip="You need to remove your account from the Authenticator App as well after deregister your device from here."
            i18n-matTooltip
            *ngIf="isCurrentUser && isTotpSelected && (isTotpDeviceRegistered$ | async)"
          >
            <i class="cs-icon cs-icon-unlink"></i>
            <ng-container i18n>Deregister auth device</ng-container>
          </button>
        </div>
      </div>
      <button class="btn btn-secondary-primary" (click)="onConfigMFA()" *ngIf="isCurrentUser">
        <i class="cs-icon cs-icon-cog"></i> <ng-container i18n>Configure MFA</ng-container>
      </button>
    </form>

    <div *ngIf="!isCurrentUser && !isCurrentAdmin">
      <div class="current-user-box">
        <i class="fal fa-ban"></i>
        <h5 i18n>You cannot update settings for your own user account.</h5>
      </div>
    </div>
  </div>
</ng-template>
